export const getAdaptivity = (state) => state.adaptivity;
